
<div class="console_modal notification_modal">
    @if (options.type !== 'spinner') {
        <div class="modal-header">
            <h4 class="modal-title">{{options.title}}</h4>
            <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.close()"></button>
        </div>
    }
    <div class="modal-body">
        @if (options.type === 'spinner') {
            <article class="spinner_content">
                <h5 class="mb-2">Loading...</h5>
                <div class="loading_box">
                    <ng-template [spinnerLoader]="true" size="2x"></ng-template>
                </div>
            </article>
        } @else {
            <div class="body_content">
                <div class="row">
                    @if (isTemplate()) {
                        <div class="col">
                            <article class="content_message">
                                <ng-template [ngTemplateOutlet]="$any(options.message)"></ng-template>
                            </article>
                        </div>
                    } @else {
                        <div class="col-2 content_type">
                            @if (options.type === 'info') { <i class="fa-solid fa-info-circle fa-4x text-primary" aria-hidden="true"></i> }
                            @else if (options.type === 'danger') { <i class="fa-solid fa-times-circle fa-4x text-danger" aria-hidden="true"></i> }
                            @else if (options.type === 'warning' || options.choice === 'multi') { <i class="fa-solid fa-exclamation-triangle fa-4x text-warning" aria-hidden="true"></i> }
                        </div>
    
                        <div class="col">
                            <article class="content_message" [innerHtml]="options.message"></article>
                            
                            @if (options.serviceError) {
                                <article class="service_error">
                                    <header class="error_head">
                                        <button type="button" class="btn p-0" (click)="errorCollapsed = !errorCollapsed" [attr.aria-expanded]="!errorCollapsed" aria-controls="collapseExample">
                                            {{(errorCollapsed ? 'Mostra' : 'Nascondi')}} dettagli
                                            @if (!errorCollapsed) {
                                                <i class="fas fa-angle-up" aria-hidden="true"></i>
                                            } @else {
                                                <i class="fas fa-angle-down" aria-hidden="true"></i>
                                            }
                                        </button>
                                    </header>
                                    <div class="alert alert-danger error_details" role="alert" #collapse="ngbCollapse" [(ngbCollapse)]="errorCollapsed">
                                        {{options.serviceError.message}}
                                    </div>
                                </article>
                            }
                        </div>
                    }
                </div>
            </div>
        }
    </div>
    @if (options.type !== 'spinner' && options.choice !== 'none') {
        <div class="modal-footer" [class.justify-content-center]="options.choice === 'single'">
            @if (options.choice === 'multi') {
                <button type="button" class="btn btn-outline-primary" (click)="cancel()">
                    {{ options.customChoiceLabels ? options.customChoiceLabels.cancel : 'Annulla' }}
                </button>
            }
            <button type="button" class="btn btn-primary" (click)="confirm()">
                {{ options.customChoiceLabels ? options.customChoiceLabels.confirm : 'OK' }}
            </button>
        </div>
    }
</div>
